export const ADD_ENTRY = 'SUMMARY/ENTRY/ADD';
export const REMOVE_ENTRY = 'SUMMARY/ENTRY/REMOVE';
export const RESET = 'SUMMARY/RESET';
export const REMOVE_ALL_ENTRIES = 'SUMMARY/ENTRY/ALL/REMOVE';
